interface BlobWithName extends Blob {
  name?: string;
}

export function downloadBlob(blob: BlobWithName, filename?: string): Node {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');

  const { name } = blob;

  a.href = url;
  a.download = filename || name || 'download';

  const clickHandler = (): number => {
    return window.setTimeout((): void => {
      URL.revokeObjectURL(url);
      a.removeEventListener('click', clickHandler);
    }, 150);
  };

  a.addEventListener('click', clickHandler, false);

  a.click();

  return a;
}
